import { IForm } from '@/components/types'

export const modalConfigBatchUpdate: IForm = {
  formItems: [
    {
      field: 'serialNumbers',
      type: 'default',
      label: '资源编号'
    },
    {
      field: 'channel',
      type: 'select',
      label: '开单渠道',
      placeholder: '请选择开单渠道',
      options: [
        { title:'新闻大图/视频扫码', value: '新闻大图/视频扫码' },
        { title:'新闻大图/视频通投', value: '新闻大图/视频通投' },
        { title:'新闻小图/三图扫码', value: '新闻小图/三图扫码' },
        { title:'新闻小图/三图通投', value: '新闻小图/三图通投' },
        { title:'QQ大图/视频', value: 'QQ大图/视频' },
        { title:'QQ小图/三投', value: 'QQ小图/三投' },
        { title:'公众号-支付', value: '公众号-支付' },
        { title:'优量汇', value: '优量汇' },
        { title:'QQ购物', value: 'QQ购物' },
        { title:'搜索直达', value: '搜索直达'},
        { title:'新闻PC端', value: '新闻PC端' },
        { title:'百度信息流', value: '百度信息流' },
        { title:'抖音', value: '抖音' },
        { title:'今日头条', value: '今日头条' },
        { title:'朋友圈', value: '朋友圈' },
        { title:'广点通-朋友圈', value: '广点通-朋友圈' },
        { title:'公众号MP', value: '公众号MP' },
        { title:'新兵营-电话', value: '新兵营-电话' },
        { title:'电话组-诊股', value: '电话组-诊股' },
        { title:'电话组-课程', value: '电话组-课程' },
        { title:'自媒体', value: '自媒体' }
      ]
    },
    {
      field: 'createUser',
      type: 'default',
      label: '开单人'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
